import styled from "styled-components";

export const ContactContainer = styled.div`
    height: 800px;
    background: #f9f9f9;
    
    
`
export const FormWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 120px;
    
    
`

export const FormContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    

    @media screen and (max-width: 480px){
        padding: 10px;
    }
`

export const Form = styled.form`
    background: rgba(171,163,241, 60%);
    z-index: 1;
    display: grid;
    margin: 0 auto;
    padding: 40px 32px;
    border-radius: 4px;
    box-shadow: 10px 10px 3px rgba(0, 0, 0, 0.4);
    
    @media screen and (max-width: 700px){
        padding: 32px 32px;
        max-width: 300px;
    }
`

export const FormH1 = styled.h1`
    margin-bottom: 40px;
    color: black;
    font-size: 20px;
    font-weight: 400;
    text-align: center;

    @media screen and (max-width: 700px){
        max-width: 250px;
    }
`

export const FormLabel = styled.label`
    margin-bottom: 8px;
    font-size: 14px;
    color: black;

    @media screen and (max-width: 700px){
        max-width: 250px;
    }
`

export const FormInput = styled.input`
    padding: 16px 16px;
    margin-bottom: 32px;
    border: none;
    border-radius: 4px;

    @media screen and (max-width: 700px){
        max-width: 250px;
    }
`

export const FormButton = styled.button`
    background: rgba(249,148,202,1);
    padding: 16px 0;
    border: none;
    border-radius: 4px;
    color: black;
    font-size: 20px;
    cursor: pointer;
    margin-top: 25px;

    &:hover{
        background: white;
        transition: .3s all ease-in-out;
    }

    @media screen and (max-width: 700px){
        max-width: 250px;
    }
`

export const Text = styled.span`
    text-align: center;
    margin-top: 24px;
    color: #fff;
    font-size: 14px;

    @media screen and (max-width: 700px){
        max-width: 300px;
    }
`

export const FormInputTextArea = styled.textarea`
    min-height: 100px;
    min-width: 350px;
    max-width: 600px;
    max-height: 900px;
    border-radius: 5px;
    padding: 10px;

    @media screen and (max-width: 700px){
        min-width: 100px;
        width: 250px;
    }
`